


























import { Component, Prop, Vue, Watch, Model } from 'vue-property-decorator'

import ReadonlyField from '@/components/base/readonlyField.vue'

@Component({
  name: 'RemoteApiSelecter',
  components: {
    ReadonlyField
  }
})
export default class RemoteApiSelecter extends Vue {
    @Model('input')
    readonly value!:number|string|number[]|string[]

    @Prop()
    readonly optionKey!:string

    @Prop({ default: 'id' })
    readonly idName!:string

    @Prop({
      type: String,
      default: '请选择'
    })
    readonly placeholder!:string

    @Prop({
      type: Boolean,
      default: false
    })
    readonly readonly!:boolean

    @Prop({
      type: Boolean,
      default: false
    })
    readonly multiple?:boolean

    @Prop()
    queryDataApi!:(query?:string|number)=>Promise<any>

    @Prop()
    displayValue!:(item:any)=>string

    loading = false

    curValue:number|string|number[]|string[]|null = null
    options:Array<any>=[]

    private isReady:boolean = false

    get readyOnlyValue () {
      let displayValues:string|null = null
      const res = this._getCurSeletItems(this.curValue)
      if (res) {
        if (this.multiple && res.constructor && res.constructor === Array) {
          displayValues = res.map(item => {
            return this.displayValue(item)
          }).join(',')
        } else {
          displayValues = this.displayValue(res || {})
        }
      }
      return displayValues
    }

    public resetQuery () {
      this.isReady = false
      this.queryData(undefined)
    }

    public clearSingleSelect () {
      let selecter = this.$refs.selecter as any
      selecter.clearSingleSelect()
    }

    private getSelectItemByValue (value:number|string) {
      const res = this.options.filter(item => {
        return item[this.idName!] === value
      })
      return res ? res[0] : undefined
    }

    private _getCurSeletItems (values:number|string|number[]|string[]|null) {
      let res:any
      if (values === null) {
        return undefined
      }
      if (this.multiple) {
        if (values && values.constructor === Array) {
          const tempRes:any[] = []
          values.forEach((value:any) => {
            const r = this.getSelectItemByValue(value)
            if (r) tempRes.push(r)
          })
          res = tempRes.length > 0 ? tempRes : undefined
        }
      } else {
        res = this.getSelectItemByValue(values as string|number)
      }
      return res
    }

    onChange (newValue:number|string|number[]|string[]|null) {
      this.$emit('input', newValue)
      this.$emit('onchange', newValue)
      if (newValue === null) {
        this.$emit('onDataItemChange', undefined)
      } else {
        const res = this._getCurSeletItems(newValue)
        this.$emit('onDataItemChange', res)
      }
    }

    @Watch('value', { deep: true, immediate: false })
    watchValue () {
      this.curValue = this.value
      const res = this._getCurSeletItems(this.value)
      if (!res && !!this.value) {
        this.queryData(undefined)
      }
    }

    queryData (query?:string|number) {
      if (!this.queryDataApi || this.isReady || this.loading) {
        return
      }
      this.loading = true
      let promise = this.queryDataApi(query)
      if (promise && promise.then) {
        return promise.then(responsedata => {
          this.options = responsedata.data!
          this.isReady = true
          const res = this._getCurSeletItems(this.curValue)
          if (!res && !!this.curValue) {
            this.onChange(null)
            this.clearSingleSelect()
          }
        }).catch(err => {
          this.$Message.error('加载数据失败:' + err.message)
        })
          .finally(() => {
            this.loading = false
          })
      }
    }

    created () {
      this.watchValue()
    }

    onOpenChange (status:boolean) {
      if (status && !this.isReady) {
        this.queryData()
      }
    }

    onQueryChange (query:string|number) {
      if (this.loading === true) {
        return query
      }
      const res = this.options.filter(item => {
        return this.displayValue(item) === query
      })
      if (!res || res.length === 0) {
        this.isReady = false
      }
      return query
    }
}
